/**
 * CanvasVariablesContext — preview substitution values for canvas screen nodes (K3, D64).
 *
 * Provides the SAMPLE-value map (`buildPreviewVariables` output) so
 * FlowOnboardingScreenNodeV2 can pass `variables` to V2ScreenView and render
 * `@variable` tokens as sample values instead of raw tokens (gap G3).
 *
 * Same architecture rationale as CanvasLocaleContext: React Context instead of
 * updateNodeData so re-renders cross React.memo boundaries automatically and
 * node data stays lean.
 */
import { createContext, useContext } from 'react';

export interface CanvasVariablesContextValue {
  /** Flat `@ref` → sample-value map (runtime `TemplateVariables` shape). */
  previewVariables: Record<string, string>;
}

export const CanvasVariablesContext = createContext<CanvasVariablesContextValue>({
  previewVariables: {},
});

export const useCanvasVariables = () => useContext(CanvasVariablesContext);
